import React, { useEffect, useRef, useState } from "react";
import {
  allColumns,
  itemsInputField as inputFieldsInit,
} from "./ApprovePayrollList.config";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { searchDuyetBangLuong } from "../../../../../redux/reducer/employee";
import { ColumnProps } from "../../../../../types/models";
import Notification from "../../../../../components/common/notification/notification";
import {
  ColumnPopoverDisplay,
  ExpandSearch,
} from "../../../../../components/common";
import "./ListPayroll.scss";
import {
  Button,
  Col,
  Input,
  InputNumber,
  Popconfirm,
  Popover,
  Row,
  Space,
  Typography,
} from "antd";
import Icons from "../../../../../assets/icons";
import { ExcelSVG, SaveWhiteIconSVG, ZipSVG } from "../../../../../assets";
import { employeeService } from "api";
import axiosClient from "../../../../../api/axiosClient";
import {
  generateFileName,
  saveTableOptions,
  generateFileNameZip,
  getTableOptions,
} from "../../../../../helper/common";

import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import { APPROVE_ACTION, APPROVE_ACTION_CODE } from "types/enums/employee";
import { setButtonsHeader, setRefreshCallPayroll } from "redux/reducer/common";

const ListPayroll = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear(); // Lấy năm hiện tại (ví dụ: 2023)
  const currentMonth = currentDate.getMonth() + 1; // Lấy tháng hiện tại (0 - 11, cần cộng thêm 1 để có giá trị tháng thực tế)
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState<any[]>([]);
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
    nam: currentYear,
    thang: currentMonth,
    trangThaiDuyet: APPROVE_ACTION_CODE.WAIT_APPROVED,
  });
  const [loading, setLoading] = useState(false);
  let savedTableOption = getTableOptions(
    "APPROVEPAYROLL_TABLE",
    localStorage.getItem("username")
  );
  const defaultColumns = savedTableOption
    ? allColumns.map((cl) => {
        if (savedTableOption.some((it) => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(
            (it) => it.dataIndex === cl.dataIndex
          );
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : allColumns;
  const [columns, setColumns] = useState<any>(
    defaultColumns.filter((e) => e.show == true)
  );
  columns.map((e) => {
    if (e.key == "index") {
      e.render = (text, record, index) => {
        const rowNumber = (currentPage - 1) * params.limit + index + 1;
        return rowNumber;
      };
    }
  });
  const [paramss, setParamss] = useState<any>({});
  const employees = useAppSelector((state) => state.employeesReducer);
  const dispatch = useAppDispatch();
  const expandRef = useRef<any>();
  const [selectedRowsKeys, setSelectedRowsKeys] = useState([]);
  const [refreshList, setRefreshList] = useState<boolean>(false);
  const onSelectChange = (selectedRowKeys) => {
    setSelectedRowsKeys(selectedRowKeys);
  };

  const rowSelection = {
    selectedRowsKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      onSelectChange(selectedRowKeys);
    },
  };
  useEffect(() => {
    dispatch(setButtonsHeader([]));
  }, []);
  const onClickSearch = async () => {
    setCurrentPage(1);
    setSelectedRowsKeys([]);
    setData([]);
    var searchFields = expandRef?.current?.getData();
    setParams({ ...params, ...searchFields, page: 1 }); // Đặt trang về 1 khi thực hiện tìm kiếm
  };

  useEffect(() => {
    expandRef?.current.setFieldValue("nam", currentYear);
    expandRef?.current.setFieldValue("thang", currentMonth);
  }, []);

  const getList = async (params) => {
    setLoading(true);
    await dispatch(searchDuyetBangLuong(params));
    setLoading(false);
  };

  useEffect(() => {
    getList({
      ...params,
    });
  }, [params, refreshList]);

  useEffect(() => {
    setData(
      employees?.DuyetBangLuongList?.map((list) => ({
        ...list,
        key: list.id,
        thamGiaBHXH:
          list.thamGiaBHXH === null
            ? null
            : list.thamGiaBHXH === "1"
            ? "1"
            : null,
      }))
    );
  }, [employees?.DuyetBangLuongList]);

  const setShowColumnsList = (showColumns) => {
    saveTableOptions(
      "APPROVEPAYROLL_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };

  const setShowColumns = (showColumns: React.SetStateAction<ColumnProps[]>) => {
    setColumns(showColumns);
  };

  const onChangePagination = (currentPage, pageSize) => {
    setCurrentPage(currentPage);
    setParams({ ...params, page: currentPage, limit: pageSize });
  };
  const onClickRoll = async () => {
    var searchFields = expandRef?.current?.getData();

    setParamss({ ...paramss, ...searchFields });
    handleExportZipRoll(params);
  };
  const handleExportZipRoll = async (params) => {
    const url = "hanhchinhnhansu/bang-luong/report";
    const baseName = "PhieuLuong_Alina_Thang_";
    const fileExtension = "zip";
    const month = params.thang;
    const fileName = generateFileNameZip(baseName, fileExtension, month);
    try {
      const response = await axiosClient.post(url, params, {
        responseType: "blob",
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      Notification("zip", "Error exporting Zip");
    }
  };
  const onClickExport = async () => {
    var searchFields = expandRef?.current?.getData();
    setParamss({ ...paramss, ...searchFields });
    handleExportExcel(params);
  };

  const handleExportExcel = async (params) => {
    const url = `hanhchinhnhansu/duyet-luong/export-excel?trangThaiDuyet=${params.trangThaiDuyet || 0}`;
    const baseName = "danh-sach-duyet-bang-luong";
    const fileExtension = "xlsx";
    const fileName = generateFileName(baseName, fileExtension);
    try {
      const response = await axiosClient.post(url, params, {
        responseType: "blob",
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      Notification("error", "Error exporting Excel");
    }
  };

  useEffect(() => {
    dispatch(
      searchDuyetBangLuong({
        page: 1,
        limit: 100,
      })
    );
  }, []);

  useEffect(() => {
    setOptionsPBFields(employees.phongBanList, "idPhongBan");
  }, [employees.phongBanList]);
  const setOptionsPBFields = (list, tenPhongBan) => {
    if (inputFieldsInit.find((field) => field.name === tenPhongBan)) {
      inputFieldsInit.find((field) => field.name === tenPhongBan).options =
        list?.map((item) => ({
          value: item.id,
          label: item.tenPhongBan,
        }));
    }
  };
  const handleSubmit = async () => {
    try {
      const datas = data.map((item) => ({
        id: item.id,
        thuongLe: item.thuongLe,
        thuongChuyenCan: item.thuongChuyenCan,
        thuongDotXuat: item.thuongDotXuat,
        thuongHoaHong: item.thuongHoaHong,
        thuongLuongThang13: item.thuongLuongThang13,
        tienLuongNgungViec: item.tienLuongNgungViec,
        dieuChinhLuongThangTruoc: item.dieuChinhLuongThangTruoc,
        truyThuBH: item.truyThuBH,
        truTamUng: item.truTamUng,
      }));

      const res = await employeeService.updateBangLuong(
        datas,
        params.thang,
        params.nam
      );
      if (res.statusCode !== 200) {
        Notification("warning", "Vui lòng liên hệ quản trị viên");
      } else {
        Notification("success", "Cập nhập thành công ");
        getList(params);
      }
    } catch (res) {
      Notification("error", "Cập nhập thất bại");
    }
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };
  const onKeyDownSearch = (e) => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };

  const numberOfColumns = columns.length;

  // Thiết lập giá trị scroll dựa vào số lượng cột
  let scrollX;
  if (numberOfColumns <= 5) {
    scrollX = 1000;
  } else if (numberOfColumns <= 10) {
    scrollX = 1600;
  } else if (numberOfColumns <= 15) {
    scrollX = 2000;
  } else if (numberOfColumns <= 20) {
    scrollX = 3000;
  } else if (numberOfColumns <= 25) {
    scrollX = 4000;
  } else if (numberOfColumns <= 30) {
    scrollX = 5000;
  } else if (numberOfColumns <= 35) {
    scrollX = 6000;
  } else {
    scrollX = 7000;
  }

  allColumns.map((record) => {
    if (record.dataIndex == "thuongLe") {
      record.render = (value, record, index) => (
        <InputNumber
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
          style={{ width: "100%" }}
          value={value}
          onChange={(value) => {
            const newData = [...data];
            newData[index]["thuongLe"] = value;
            setData(newData);
          }}
        />
      );
    }
    if (record.dataIndex == "thuongChuyenCan") {
      record.render = (value, record, index) => (
        <InputNumber
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
          style={{ width: "100%" }}
          value={value}
          onChange={(value) => {
            const newData = [...data];
            newData[index]["thuongChuyenCan"] = value;
            setData(newData);
          }}
        />
      );
    }
    if (record.dataIndex == "thuongDotXuat") {
      record.render = (value, record, index) => (
        <InputNumber
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
          style={{ width: "100%" }}
          value={value}
          onChange={(value) => {
            const newData = [...data];
            newData[index]["thuongDotXuat"] = value;
            setData(newData);
          }}
        />
      );
    }
    if (record.dataIndex == "thuongHoaHong") {
      record.render = (value, record, index) => (
        <InputNumber
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
          style={{ width: "100%" }}
          value={value}
          onChange={(value) => {
            const newData = [...data];
            newData[index]["thuongHoaHong"] = value;
            setData(newData);
          }}
        />
      );
    }
    if (record.dataIndex == "thuongLuongThang13") {
      record.render = (value, record, index) => (
        <InputNumber
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
          style={{ width: "100%" }}
          value={value}
          onChange={(value) => {
            const newData = [...data];
            newData[index]["thuongLuongThang13"] = value;
            setData(newData);
          }}
        />
      );
    }
    if (record.dataIndex == "tienLuongNgungViec") {
      record.render = (value, record, index) => (
        <InputNumber
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
          style={{ width: "100%" }}
          value={value}
          onChange={(value) => {
            const newData = [...data];
            newData[index]["tienLuongNgungViec"] = value;
            setData(newData);
          }}
        />
      );
    }
    if (record.dataIndex == "dieuChinhLuongThangTruoc") {
      record.render = (value, record, index) => (
        <InputNumber
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
          style={{ width: "100%" }}
          value={value}
          onChange={(value) => {
            const newData = [...data];
            newData[index]["dieuChinhLuongThangTruoc"] = value;
            setData(newData);
          }}
        />
      );
    }
    if (record.dataIndex == "truyThuBH") {
      record.render = (value, record, index) => (
        <InputNumber
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
          style={{ width: "100%" }}
          value={value}
          onChange={(value) => {
            const newData = [...data];
            newData[index]["truyThuBH"] = value;
            setData(newData);
          }}
        />
      );
    }
    if (record.dataIndex == "truTamUng") {
      record.render = (value, record, index) => (
        <InputNumber
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
          style={{ width: "100%" }}
          value={value}
          onChange={(value) => {
            const newData = [...data];
            newData[index]["truTamUng"] = value;
            setData(newData);
          }}
        />
      );
    }
    if (record.dataIndex == "lyDo") {
      record.render = (value, record, index) => {
        if (selectedRowsKeys.includes(record?.id))
          return (
            <Input
              style={{ width: "100%" }}
              value={value}
              onChange={(e) => {
                const newData = [...data];
                newData[index]["lyDo"] = e?.target?.value;
                setData(newData);
              }}
            />
          );

        return value;
      };
    }
  });

  const handleActionSelectedRowkeys = async (action: string) => {
    if (data?.length) {
      const payload = data
        .filter((item: any) => selectedRowsKeys.includes(item.id))
        .map((item: any) => ({
          id: item.id,
          lyDo: item.lyDo,
          trangThaiDuyet: item.trangThaiDuyet,
        }));
      try {
        const res = await employeeService.approvePayroll(payload, action);
        Notification("success", res.data.message || "Thao tác thành công");
        setRefreshList(!refreshList);
        setSelectedRowsKeys([]);
        dispatch(setRefreshCallPayroll());
      } catch (err: any) {
        Notification("error", err.message || "Có lỗi xảy ra");
      }
    }
  };

  const renderActionSelectedRowkeys = () => {
    if (selectedRowsKeys.length) {
      return (
        <Col className="space-button">
          <Space align="start">
            {params.trangThaiDuyet === APPROVE_ACTION_CODE.WAIT_APPROVED && (
              <Popconfirm
                className="danger-confirm"
                title="Bạn có chắc chắn muốn duyệt bảng chấm công?"
                onConfirm={() =>
                  handleActionSelectedRowkeys(APPROVE_ACTION.APPROVAL)
                }
              >
                <Button type="primary">Duyệt</Button>
              </Popconfirm>
            )}
            {params.trangThaiDuyet === APPROVE_ACTION_CODE.APPROVED && (
              <Button
                type="default"
                onClick={() =>
                  handleActionSelectedRowkeys(APPROVE_ACTION.NOT_APPROVAL)
                }
              >
                Bỏ duyệt
              </Button>
            )}
            {params.trangThaiDuyet === APPROVE_ACTION_CODE.WAIT_APPROVED && (
              <Button
                type="default"
                danger
                onClick={() =>
                  handleActionSelectedRowkeys(APPROVE_ACTION.CANCEL)
                }
              >
                Hủy
              </Button>
            )}
          </Space>
        </Col>
      );
    } else return null;
  };
  return (
    <div className="recruitment-list" tabIndex={0}>
      <div className="recruitment-container">
        <div className="container" onKeyDown={onKeyDownSearch}>
          <ExpandSearch
            ref={expandRef}
            fields={inputFieldsInit}
            onClickSearch={onClickSearch}
            isSearchExpend={false}
            isResetField={false}
          />
        </div>
        <div className="container" onKeyDown={onKeyDown}>
          <Space style={{ width: "100%" }} direction="vertical">
            <Row justify={"space-between"} gutter={[16, 8]}>
              <Col>
                <Popover
                  trigger="click"
                  placement="topRight"
                  content={
                    <ColumnPopoverDisplay
                      setShowColumns={setShowColumns}
                      columns={columns}
                      width={"800px"}
                      columnSizes={{ xs: 10, sm: 12, md: 8, lg: 8, xl: 8 }}
                    ></ColumnPopoverDisplay>
                  }
                >
                  <Button
                    icon={<Icons.bars rev={0} />}
                    className="btn-sub"
                    type="ghost"
                  >
                    Cột hiển thị
                  </Button>
                </Popover>
              </Col>
              {renderActionSelectedRowkeys()}
              <Col>
                <Space style={{ width: "100%" }}>
                  <Button
                    className="custom-btn"
                    type="default"
                    onClick={onClickExport}
                    icon={<ExcelSVG />}
                  >
                    <Typography>Xuất báo cáo</Typography>
                  </Button>
                  {/* <Button
                    className="custom-btn"
                    type="default"
                    onClick={onClickRoll}
                    icon={<ZipSVG />}
                  >
                    <Typography>Xuất phiếu lương</Typography>
                  </Button> */}

                  <Button
                    className="custom-btn"
                    type="primary"
                    htmlType="submit"
                    onClick={handleSubmit}
                    icon={<SaveWhiteIconSVG />}
                  >
                    Lưu lại
                  </Button>
                </Space>
              </Col>
            </Row>
            {data && (
              <CustomResizableTable
                rowSelection={{
                  type: "checkbox",
                  ...rowSelection,
                }}
                setShowColumns={setShowColumnsList}
                pagination={{
                  position: ["bottomRight"],
                  showSizeChanger: true,
                  total: employees.DuyetBangLuongTotal,
                  onChange: onChangePagination,
                  current: currentPage,
                }}
                // rowKey={(record) => record.id}
                columns={columns}
                dataSource={data}
                bordered={true}
                loading={loading}
                scroll={{ x: scrollX }}
                size="middle"
              />
            )}
          </Space>
        </div>
      </div>
    </div>
  );
};

export default ListPayroll;
